module.exports = __webpack_public_path__ + "favicon.ff57a71f.ico";